export class AccordionSection {
  $element: HTMLElement
  $items: HTMLDivElement[]
  $itemTriggers: HTMLButtonElement[]
  $itemDrawers: HTMLDivElement[]

  constructor($element: HTMLElement) {
    this.$element = $element

    this.$items = [...$element.querySelectorAll('.section-accordion__item')] as HTMLDivElement[]
    this.$itemTriggers = this.$items.map(item => item.querySelector('.section-accordion__item-trigger') as HTMLButtonElement)
    this.$itemDrawers = this.$items.map(item => item.querySelector('.section-accordion__item-drawer') as HTMLDivElement)

    for (let i = 0; i < this.$items.length; i++) {
      this.$itemTriggers[i]
        .addEventListener('click', this.toggleItem.bind(this, i))
    }
  }

  toggleItem(index: number): void {
    const $trigger = this.$itemTriggers[index]
    const $drawer = this.$itemDrawers[index]

    const expanded = $trigger.getAttribute('aria-expanded') === 'true'
    const newExpanded = !expanded

    $trigger.setAttribute('aria-expanded', newExpanded ? 'true' : 'false')
    $drawer.setAttribute('aria-hidden', newExpanded ? 'false' : 'true')
  }
}
